module.exports = __webpack_public_path__ + "static/media/fill_pattern.vertex.25a5ce16.glsl";